import styled, {css} from 'styled-components';
import { rem } from 'polished';
import { TitleSmall400 } from '@nebula/global-styles';
import { planCardGridPlacement } from '../index.styles';
import { tabletMin } from '../../constants';

export const PlanCardWrapper = styled.div<{ $gridColumn: number }>`
  ${planCardGridPlacement}
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  height: 100%;

  @media ${tabletMin} {
    padding-bottom: ${rem(24)};
  }

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    margin-top: 0;
  }
`;

export const CurrentPlanTag = styled.span<{ $isCurrent?: boolean }>`
  display: ${({ $isCurrent = false }) => ($isCurrent ? 'block' : 'none')};
  align-self: center;
  width: 80%;
  padding: ${rem(6)} ${rem(8)};
  font-size: ${rem(12)};
  font-weight: 500;
  line-height: ${rem(16)};
  color: ${({ theme }) => theme.color.ui.grey[90]};
  background-color: ${({ theme }) => theme.color.ui.grey[20]};
  text-align: center;
  border-radius: 0 0 ${rem(12)} ${rem(12)};

  @media ${tabletMin} {
    display: block;
    visibility: ${({ $isCurrent = false }) => ($isCurrent ? 'visible' : 'hidden')};
  }
`;

const planCardBase = css`
  min-width: 0;
  width: 100%;
  flex: 1 1 auto;
  border-radius: ${rem(12)};
  padding: ${rem(12)} ${rem(8)};
  min-height: ${rem(80)};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${tabletMin} {
    padding: ${rem(20)};
    margin-top: 0;
  }
`;

export const BasicPlanCard = styled.div<{ gradient?: string }>`
  ${planCardBase}
  background: ${({ gradient }) => gradient};
  border: 1px solid #e2e4e7;
  color: ${({ theme }) => theme.color.ui.grey[90]};
  justify-content: flex-start;
`;

export const PaidPlanCard = styled.div<{ gradient?: string }>`
  ${planCardBase}
  background: ${({ gradient }) => gradient};
  color: #ffffff;
  justify-content: flex-start;

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    padding: ${rem(24)} ${rem(20)};
  }
`;

export const PlanCardName = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  color: inherit;
  margin: 0;
  font-weight: 700;
  font-size: ${rem(20)};
  line-height: ${rem(32)};
`;

export const PlanCardIcon = styled.div`
  flex-shrink: 0;
  position: relative;
  width: ${rem(24)};
  height: ${rem(24)};
  overflow: hidden;

  img {
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: ${rem(30)};
    width: auto;
    max-width: none;
  }
`;

export const PlanCardDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PlanCardTagline = styled(TitleSmall400)`
  margin-top: 0;
  color: inherit;
  margin-bottom: 0;
  font-size: ${rem(14)};
  line-height: ${rem(20)};
`;

export const PlanCardPrice = styled.div`
  font-size: ${rem(16)};
  font-weight: 500;
  line-height: ${rem(24)};
  margin-top: ${rem(8)};
`;